/**
 * Pure polar → screen-percent math for the circular table. Seat 0 (angle 0
 * from the engine's board.ts) is rotated to render at 12 o'clock — a purely
 * cosmetic default orientation; a replay has no single "you" perspective to
 * rotate around like a live seat would.
 */
const ROTATION_OFFSET = -Math.PI / 2;

export interface ScreenPosition {
  readonly left: string;
  readonly top: string;
}

/** `radius` is in the engine's normalized units (seats = 1, dice ≤ 0.65). */
export function polarToPercent(
  angle: number,
  radius: number,
  ringPercent = 42,
): ScreenPosition {
  const rotated = angle + ROTATION_OFFSET;
  return {
    left: `${50 + Math.cos(rotated) * radius * ringPercent}%`,
    top: `${50 + Math.sin(rotated) * radius * ringPercent}%`,
  };
}

export function seatAngle(seatIndex: number, seatCount: number): number {
  return ((Math.PI * 2) / seatCount) * seatIndex;
}
